import { Grid } from '@mui/material';
import React from 'react'
import { SpwkUtil } from '../../dao/SpwkUtil';
import { SpwkUtilV3 } from '../../dao/SpwkUtilV3';
import { UniAnswer } from '../../dao/UniAnswer';
import { UniForm } from '../../dao/UniForm';
import { UniQuestion } from '../../dao/UniQuestion';
import UcFinishedPage from './components/UcFinishedPage';
import UcQuestionPanel from './components/UcQuestionPanel';
import { Member } from '../../dao/Member';

type Props = {
  tab_step: TabStep;
  _SpwkBaseForm: UniForm | null | undefined;
  _UniFormList: UniForm[] | undefined;
  _UniAnswer: UniAnswer | null | undefined;
  _Member: Member | null | undefined;
}

const UcTabStepContent = ({ tab_step, _SpwkBaseForm, _UniFormList, _UniAnswer, _Member, ...props }: Props) => {

  if (_SpwkBaseForm == null || _UniFormList == null) {
    return <></>;
  }

  let chapter = tab_step.chapter;
  let questions: UniQuestion[] = SpwkUtil.GetChapterQuestionsV3(chapter, _SpwkBaseForm, _UniFormList);

  return (
    <Grid item >{render_ChapterContent(chapter, questions)}</Grid>
  )

  function render_ChapterContent(chapter: string, questions: UniQuestion[]): React.ReactNode {

    if (chapter === CHAPTER_FinishPage) {
      return <UcFinishedPage _UniAnswer={_UniAnswer} />;

    } else {
      return (
        <Grid container>
          <Grid item >
            <UcQuestionPanel questions={questions} member={_Member} />
          </Grid>
        </Grid>
      );
    }




    // 當不同章節有特殊改變的地方時，考慮拆分成不同UC 如下
    // switch (chapter) {
    //   case SpwkUtil.CHAPTER_基本資料: return <UcBasicInfo questions={questions} />
    //   case SpwkUtil.CHAPTER_作業經歷: return <UcWorkExp questions={questions} />
    //   ...
    // }
  }


}

export default UcTabStepContent




export function GetSpwkTabSteps(uni_func_guids: string[], is_admin: boolean) {

  let steps: TabStep[] = [];

  steps.push(new TabStep(SpwkUtil.CHAPTER_基本資料));// CH1
  steps.push(new TabStep(SpwkUtil.CHAPTER_作業經歷));// CH2

  if (uni_func_guids.length === 1 && uni_func_guids.includes('_A98')) {//只有A98不需要檢查時期
    //pass
  } else {
    if (is_admin) {// 只有後台才顯示檢查時期
      steps.push(new TabStep(SpwkUtil.CHAPTER_檢查時期));// CH3
    }
  }

  if (uni_func_guids.filter(x => x !== SpwkUtilV3.B02_func_guid).length > 0) {
    // 排除了聽力還有其他紀錄，則要加上 CH4既往病史
    steps.push(new TabStep(SpwkUtil.CHAPTER_既往病史));
  }

  if (uni_func_guids.includes(SpwkUtilV3.B02_func_guid)) {
    steps.push(new TabStep(SpwkUtil.CHAPTER_既往病史_噪音作業));// B02.CH4
  }

  steps.push(new TabStep(SpwkUtil.CHAPTER_生活習慣));// CH5

  if (uni_func_guids.filter(x => x !== SpwkUtilV3.B02_func_guid).length > 0) {
    // 排除了聽力還有其他紀錄，則要加上 CH6既往病史
    steps.push(new TabStep(SpwkUtil.CHAPTER_自覺症狀));// CH6
  }

  if (uni_func_guids.includes(SpwkUtilV3.B02_func_guid)) {
    steps.push(new TabStep(SpwkUtil.CHAPTER_自覺症狀_噪音作業));// B02.CH4
  }

  if (uni_func_guids.includes(SpwkUtilV3.A98_func_guid)) {
    steps.push(new TabStep(SpwkUtil.CHAPTER_疲勞狀況));// A98 only
  }

  if (is_admin) {// 只有後台才顯示檢查時期
    if (IsContainsCH7(uni_func_guids)) {
      steps.push(new TabStep(SpwkUtil.CHAPTER_環境監測));// CH7
    }
  }

  steps.push(new TabStep(CHAPTER_FinishPage));// 完成問卷畫面

  return steps;
}


const CHAPTER_FinishPage = "FinishPage";

export class TabStep {
  chapter: string = "";

  constructor(chapter: string) {
    this.chapter = chapter;
  }

}

/** Is至少有一個特作需要顯示 CH7 環境監測 */
function IsContainsCH7(uni_func_guids: string[]) {
  for (const func_guid of uni_func_guids) {
    if (IsNeedCH7(func_guid)) {
      return true;// 任何特作需要 CH7，則顯示此章節
    }
  }

  return false;
}

/** 判斷 單一一個特作，是否需要 CH7 環境監測 */
function IsNeedCH7(func_guid: string) {
  // @2023-02-21 暫時先這樣判斷
  // B03，只有一題獨立的問題。但也算是需要顯示 CH7
  // 不需要環境監測的特作: "!A01﹋!A98﹋!B04﹋!B21﹋!B22﹋!B28﹋!B29﹋!B30﹋!B31"
  let no_ch7_func_guids = ["_A01", "_A98", "_B04", "_B21", "_B22", "_B28","_B29", "_B30", "_B31"];
  if (no_ch7_func_guids.includes(func_guid)) {
    return false;
  } else {
    return true;
  }

}

